import React from 'react';
import {doppeActionTypeDefineViewerMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {doppeActionTypeCountdown} from './doppe-action-type-countdown';

export const doppeActionTypeCountdownViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeCountdown, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeCountdownWidget: (await import(
                './doppe-action-type-countdown-widget/doppe-action-type-countdown-widget'
            )).DoppeActionTypeCountdownWidget,
        };
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {DoppeActionTypeCountdownWidget} = viewerComponents;

        return (
            <DoppeActionTypeCountdownWidget
                {...renderProps}
            />
        );
    },
});
